// CSS 

//Lib 

// Event, Dialog 

// Api
import api from '@/api/baseApi';

// Constant 
import { SETTINGS_EXTRA_SERVICE_API } from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { EXTRA_SERVICE_HISTORY_FILTER_BY, REPORT_ISSUES_TYPE_DESCRIPTION } from "@/constant/extraService";

// Extend
import baseExtraService from '@/scripts/extraService/baseExtraService';

// Components 
import CaretTop from "@/views/component/Icon/CaretTop.vue";
import CaretBottom from "@/views/component/Icon/CaretBottom.vue";

// Function 
const queryString = require('query-string');

export default {

    components: {
        CaretTop,
        CaretBottom,
    },

    extends: baseExtraService,

    data() {
        return {
            reportIssuesTypeDescription: REPORT_ISSUES_TYPE_DESCRIPTION,
            filterList: [
                {
                    value: EXTRA_SERVICE_HISTORY_FILTER_BY.ALL,
                    label: "All",
                },
                {
                    value: EXTRA_SERVICE_HISTORY_FILTER_BY.PENDING,
                    label: "Pending",
                },
                {
                    value: EXTRA_SERVICE_HISTORY_FILTER_BY.IN_PROGRESS,
                    label: "In progress",
                },
                {
                    value: EXTRA_SERVICE_HISTORY_FILTER_BY.APPROVED,
                    label: "Approved",
                },
                {
                    value: EXTRA_SERVICE_HISTORY_FILTER_BY.REJECTED,
                    label: "Rejected",
                },
            ],

            orderByList: [
                {
                    value: "A.ID",
                    label: "ID",
                },
                {
                    value: "A.STATUS",
                    label: "Status",
                },
                {
                    value: "A.LAST_MODIFIED_AT",
                    label: "Updated at",
                },
                {
                    value: "A.CREATED_AT",
                    label: "Created at",
                },
            ],

            pagination: {
                status: EXTRA_SERVICE_HISTORY_FILTER_BY.ALL,
                orderBy: 'A.CREATED_AT',
                directionSort: 'DESC',
                pageIndex: 1,
                pageSize: 20,
                outRowsNumber: 0,
            },
            listData: [],
            toogleFilterMobile: false,
        }
    },

    created() {
        this.getData();
        window.addEventListener('resize', this.onResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    },
    onResize() {
        this.toogleFilterMobile = false
    },
    methods: {
        toogleFilterPanelMobile() {
            this.toogleFilterMobile = !this.toogleFilterMobile
        },

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        //#region Action
        action(param) {
            let action = this.$action;
            switch (param) {
                case action.CLICK_REFRESH_EXTRA_SERVICE_HISTORY_VIEW:
                    this.getData();
                    break;
            }
        },
        //#endregion

        // Sort list
        sortList(element) {
            this.pagination.pageIndex = 1;
            this.pagination.orderBy = element;
            if (this.pagination.directionSort === 'ASC') {
                this.pagination.directionSort = 'DESC'
            } else {
                this.pagination.directionSort = 'ASC'
            }
            this.getData();
        },

        // Pagination size change
        handleSizeChange(pageSize) {
            this.pagination.pageIndex = 1;
            this.pagination.pageSize = pageSize;
            this.getData();
        },

        // Pagination page change
        handleCurrentChange(element) {
            this.pagination.pageIndex = element;
            this.getData();
        },

        //#region Get data
        getData() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            api.baseRequest(SETTINGS_EXTRA_SERVICE_API.HISTORY_VIEW, null, `?${queryString.stringify(this.pagination)}`)
                .then((res) => {
                    let responseData = res.data;
                    let pagingItem = responseData.pagingItem;
                    this.listData = responseData.data;
                    this.pagination.orderBy = pagingItem.orderBy;
                    this.pagination.directionSort = pagingItem.directionSort;
                    this.pagination.pageIndex = pagingItem.pageIndex;
                    this.pagination.pageSize = pagingItem.pageSize;
                    this.pagination.outRowsNumber = pagingItem.outRowsNumber;
                    this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.listData);
                })
                .catch(error => {
                    this.processCatchApiRequest(error, "Extra service history view failed ...")
                });
        },
        //#endregion 
    },
}